export default {"src":"/_next/static/media/RabbitMQ.a7e9c99a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};